<table
    class="table-auto w-full bg-transparent mb-10"
    mat-table
    matSort
    [dataSource]="ActividadReciente"
    #solicitudes>

    <!-- Estado -->
    <ng-container matColumnDef="descripcion">
        <td mat-cell *matCellDef="let actividad" class="border border-gray-300">
            <div
                class="pr-6 text-sm min-w-90"
            >
                {{ actividad.descripcion }}
            </div>
        </td>
    </ng-container>

    <!-- Gestión -->
    <ng-container matColumnDef="fecha">
        <td mat-cell *matCellDef="let actividad" class="border border-gray-300">
            <span class="whitespace-nowrap pr-6 text-sm ">
                {{ actividad.fechaModificacion | date: 'medium'}}
            </span>
        </td>
    </ng-container>

    <tr class="order-row h-10 border border-gray-300" mat-row *matRowDef="let row; columns: actividesTableColumns;"></tr>
</table>